import { $t } from '@/i18n';
const getOrgSchema = () => ({
    id: 'org',
    title: $t('k_dc7f55f9'),
    type: 'object',
    readonly: true,
    'uc:collapsed': true,
    'uc:bindable': false,
    methods: [
        {
            id: 'searchStaffs',
            title: $t('k_5d911031'),
            arguments: [
                { id: 'q', type: 'string', description: $t('k_688d063'), default: '' },
            ],
        },
        {
            id: 'fetchStaffs',
            title: $t('k_b4b19a60'),
            arguments: [
                { id: 'userId', type: 'string', description: $t('k_50e0cc3f'), default: '' },
            ],
        },
    ]
});
export default getOrgSchema;
